import { ComponentRef, forwardRef } from "react";

import { Button, ButtonProps } from "@/components/ui/button";

import { mapProviderToDisplayName } from "../ProviderDropdown/utils";
import { HUGGINGFACE_PROVIDER } from "./constants";
import { useParameters } from "./store";
import { ModelNameButton } from "./ModelNameButton";
import { observer } from "mobx-react-lite";

interface ParametersTriggerProps extends ButtonProps {
  readonly?: boolean;
  triggerLabel?: string;
  triggerLogo?: React.ReactNode | null;
  triggerVariant?: ButtonProps["variant"];
  buttonSize?: ButtonProps["size"];
  showIcon?: boolean;
  showTooltip?: boolean;
}

export const ParametersTrigger = observer(
  forwardRef<ComponentRef<typeof Button>, ParametersTriggerProps>(
    (
      {
        readonly = false,
        triggerLabel,
        triggerLogo,
        triggerVariant,
        buttonSize,
        showIcon = true,
        showTooltip = true,
        ...props
      },
      ref,
    ) => {
      const store = useParameters();
      const provider = store.provider?.name;

      const modelName =
        store.provider?.name === HUGGINGFACE_PROVIDER
          ? store.inferenceClientName || ""
          : store.modelName || "";

      const providerDisplay = mapProviderToDisplayName(provider || "");

      return (
        <ModelNameButton
          ref={ref}
          provider={provider}
          modelName={modelName}
          providerDisplay={providerDisplay}
          readonly={readonly}
          label={triggerLabel}
          logo={triggerLogo}
          showTooltip={showTooltip}
          showIcon={showIcon}
          variant={triggerVariant}
          size={buttonSize}
          {...props}
        />
      );
    },
  ),
);
